<template lang="pug">
div
  el-card.card-container(shadow="hover")
    filtro-pvtn(
      @pesquisar="pesquisar",
      @limpar="limpar",
      :filtro="filtro",
      placeholder="Informe o ano"
    )
  el-card.card-container(shadow="hover")
    div#tableHeader
      h3(style="marginTop: 1%; marginLeft : 1%") Listagem
      el-button#addPvtnButton(
        type="primary",
        round size="medium",
        @click="adicionarPvtn"
        ) Adicionar PVTN +
    table-generica(
      :colunas="colunas",
      :botoesAcao="botoesAcao",
      :dados='pvtns'
    )
</template>

<script>
import { mapActions } from 'vuex'
import FiltroPvtn from '@/screens/analise/vtn/FiltroPvtn'
import TableGenerica from '@/components/TableGenerica'
import Util from '@/utils/utils'

export default {
  components: {
    FiltroPvtn,
    TableGenerica
  },

  data () {
    return {
      filtro: { },
      colunas: [
        {
          prop: 'inicio',
          label: 'Vigência inicial',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'fim',
          label: 'Vigência final',
          width: 'auto',
          formatter: Util.formatEmptyRow
        }
      ],
      pvtns: []
    }
  },

  async mounted () {
    this.pvtns = await this.findVigencias()
  },

  methods: {
    ...mapActions({
      findVigencias: 'vtn/getVigencias',
      findVigenciasByYear: 'vtn/getVigenciasByYear',
      deleteVtnByIdVigencia: 'vtn/deleteVtnByIdVigencia'
    }),

    async pesquisar (filtro) {
      if (filtro.campoSimplificado) {
        this.pvtns = await this.findVigenciasByYear(filtro.campoSimplificado)
      } else {
        this.pvtns = await this.findVigencias()
      }
    },

    limpar () {
      this.filtro = {}
      this.pesquisar(this.filtro)
    },

    botoesAcao (pvtn) {
      return [
        {
          click: this.visualizarPvtn.bind(this, pvtn),
          icon: 'visibility',
          title: 'Visualizar',
          active: true
        },
        {
          click: this.editarPvtn.bind(this, pvtn),
          icon: 'edit',
          title: 'Editar',
          active: true
        },
        {
          click: this.excluirPvtn.bind(this, pvtn),
          icon: 'delete',
          title: 'Excluir',
          active: true
        }
      ]
    },

    visualizarPvtn (pvtn) {
      this.$router.push({ name: 'pvtn/adicionar',
        params: {
          isEdicao: true,
          pvtnEdicao: pvtn,
          isVisualizar: true
        }
      })
    },

    editarPvtn (pvtn) {
      this.$router.push({ name: 'pvtn/adicionar',
        params: {
          isEdicao: true,
          pvtnEdicao: pvtn,
          isVisualizar: false
        }
      })
    },

    async excluirPvtn (pvtn) {
      await this.deleteVtnByIdVigencia(pvtn.id)
      this.pvtns = await this.findVigencias()
    },

    adicionarPvtn () {
      this.$router.push({ name: 'pvtn/adicionar', params: { isEdicao: false } })
    }
  }
}
</script>

<style scss scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

#tableHeader {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1%;
}

#addPvtnButton {
  height: min-content;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/ConfigurarVtn.vue